import { featureConfig } from 'core/config/featureConfig';
import LoadingScreen from 'core/navigation/loading-screen/LoadingScreen';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { signInAnonymouslyFirebase } from 'core/store/reducers/appReducer/appSliceThunk';
import { getCurrentUser } from 'core/utils/firebaseUtil';

function AnonymousAuth() {
	if (!featureConfig.isShareCanvasEnabled) return null;
	const dispatch = useDispatch();
	const [isAnonymousLoginInProgress, setIsAnonymousLoginInProgress] = useState(0);
	useEffect(() => {
		(async () => {
			await getCurrentUser()
				.then((user) => {
					if (user) {
						setIsAnonymousLoginInProgress(3);
					} else throw new Error('No user found');
				})
				.catch(() => {
					setIsAnonymousLoginInProgress(1);
					// Add your anonymous login logic here
					dispatch(signInAnonymouslyFirebase()).finally(() => {
						setIsAnonymousLoginInProgress(2);
					});
				});
		})();
	}, [dispatch]);
	useEffect(() => {
		if (isAnonymousLoginInProgress === 2) {
			getCurrentUser().then(() => {
				setIsAnonymousLoginInProgress(4);
			});
		} else if (isAnonymousLoginInProgress === 3) {
			setIsAnonymousLoginInProgress(4);
		}
	}, [isAnonymousLoginInProgress]);
	if (isAnonymousLoginInProgress < 4) {
		return <LoadingScreen />;
	}
	return <Outlet />;
}

export default AnonymousAuth;
